module.exports = __webpack_public_path__ + "img/failAuditBlue.01d345bb.png";